<template>
    <div v-if="cert_data != null" >
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <center>
            <v-btn class="button no-display" @click="print"> Print </v-btn>
            <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
        </center>
        <template>
            <div v-if="show == true" ref="document">
                <!-- {{org_basic_data}} -->
                <div class="printdiv v-card">
                    <v-row justify="center">
                        <v-col cols="2" sm="2" md="2" align="center">
                                    <span style="font-weight: bolder;">CBSE Affiliation <br/>No: {{ org_basic_data.cbsc_no }}</span>
                                    <img v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo"  width="70%" alt="logo"/>
                                    <span style="text-transform: uppercase;font-weight: bold;font-size: 0.8em;">Sanjivani Academy</span>
                        </v-col>
                        <v-col cols="12" sm="10" md="10">
                             
                                        <strong><span style="padding-left: 25%;" v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</span></strong>
                                        <strong><span style="padding-left: 20%;">Udise No : {{ cert_data.udise_no }}</span></strong> 
                                        <strong><h1 style="padding-left: 25%;" class="header-style">Sanjivani <span class="span-first-letter">A</span>cademy</h1></strong>
                                        <strong><span v-if="org_basic_data.address">At :{{org_basic_data.address}}</span></strong>
                                
                            <v-row dense>
                                    <v-col cols="6">
                                        <span class="text-css" v-if="org_basic_data.phone">Phone : {{ org_basic_data.phone }}</span>
                                    </v-col>
                                    <v-col cols="6">
                                        <span class="text-css" v-if="org_basic_data.address">Fax : {{ }}</span>
                                    </v-col>
                            </v-row>
                            <v-row dense style="margin-top: -4px;">
                                <v-col cols="6">
                                  <span class="text-css" v-if="org_basic_data.email">e-mail : {{ org_basic_data.email }}</span>
                                </v-col>
                                <v-col cols="6">
                                  <span class="text-css" v-if="org_basic_data.website">website : {{ org_basic_data.website }}</span>
                                </v-col>
                            </v-row>
               
                    </v-col>
                    <!-- <v-col cols="12" sm="2" md="2" align="left">
                            <strong><span >Udise No : {{ cert_data.udise_no }}</span></strong>
                    </v-col> -->
                    </v-row>
                    <hr style="border: solid 1px;"></hr>
                    <v-row justify="center" class="ml-2">
                        <v-col cols="12" sm="4" md="4">
                            <strong>SRES/SA/{{ cert_data.ay }}</strong><br />
                        </v-col>
                        <v-col cols="12" sm="5" md="5"></v-col>
                                <v-col align="right" cols="12" sm="3" md="3">
                        <strong>
                                <span style="margin-right: 15%">Date :{{ cert_data.cert_date }} </span>
                        </strong>
                        </v-col>
                    </v-row>
                    <center>
                        <strong>
                            <span class="certificate-text">Bonafide Certificate</span >
                        </strong>
                    </center>
                    <br />
                    <v-row class="main-row">
                        <v-col cols="12" sm="12" md="12" style="font-size: 1.3em">
                        <!-- This is to verify that Mast/Miss <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.stud_name }}</span></strong> -->
                        <span style="padding-left: 110px;">This is to verify that Mast/Miss </span>
                        <strong><span style="border-bottom: 2px solid #000;width: 62%;display: inline-block;line-height: 1;">{{ cert_data.stud_name }}</span></strong> is a
                        <br />
                        <br/>
                        <span>student of our school studying in Grade <strong><span style="border-bottom: 2px solid #000;width: 12%;display: inline-block; line-height: 1;" >{{ cert_data.std }}</span></strong>
                        </span>
                            Div <strong><span style="border-bottom: 2px solid #000;width: 12%;display: inline-block;line-height: 1;">{{ cert_data.div }}</span></strong>
                            in the academic year <strong><span style="border-bottom: 2px solid #000;width: 12%;display: inline-block; line-height: 1;">{{ cert_data.ay }}</span></strong>
                            <br />
                            <br />
                            His / Her Date of birth according to our record is <strong><span style="border-bottom: 2px solid #000;width: 20%;display: inline-block; line-height: 1;">{{ cert_data.dob }}</span></strong>
                            <br />
                            <br />
                            (In words <strong><span style="border-bottom: 2px solid #000;width: 90%;display: inline-block; line-height: 1;">{{ cert_data.dob_words }}</span>)</strong>
                            <br />
                            <br />
                            Place of Birth <strong><span style="border-bottom: 2px solid #000;width: 32%;display: inline-block; line-height: 1;">{{ cert_data.place_of_birth }}</span></strong>
                            Caste <strong><span style="border-bottom: 2px solid #000;width: 32%;display: inline-block; line-height: 1;">{{ cert_data.caste }}</span></strong>
                            .To the best of my
                            <br />
                            <br />
                            knowledge, he/she bears a good moral character.
             
                            </v-col>
                    </v-row>
                    <br/>
                    <br/>
                    <v-row dense style="font-size: 1.3em;margin-left: 8px;padding-left: 4px;">
                        <strong><span>Place : {{ }}</span></strong>
                    </v-row>
                    <br />
                    <br />
                    <div style="font-size: 1.3em;float: left;padding-left: 2px;margin-left: 8px;"><strong>Date : {{ cert_data.cert_date }}</strong></div>
                    <div style="font-size: 1.3em;float: right;padding-right: 2px;margin-right: 8px;"><strong>PRINCIPAL</strong></div>
                    <br />
                    <br />
                </div>
            </div>

            <!-- </v-card> -->
        </template>
    </div>
</template>

<script>
    import axios from "axios";
    import VueHtml2pdf from "vue-html2pdf";
    import html2pdf from "html2pdf.js";
    import jsPDF from "jspdf";
    import html2canvas from "html2canvas";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar: false,
                fetch_loader: false,
                gen_cert_loader: false,
                show_cert_loader: false,
                search: "",
                dialog: false,
                awspath: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                data_list: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                cert_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                overlay: false,
                show: true,
                org_basic_data: [],
                htmlToPdfOptions: {
                    margin: 0,

                    filename: `hehehe.pdf`,

                    image: {
                        type: "jpeg",
                        quality: 0.98,
                    },

                    enableLinks: false,

                    html2canvas: {
                        scale: 1,
                        useCORS: true,
                    },

                    jsPDF: {
                        unit: "in",
                        format: "a4",
                        orientation: "landscape",
                    },
                },
                progress: 0,
            };
        },
        watch: {
            progress(val) {
                this.$emit("progress", val);
            },
        },
        components: {
            VueHtml2pdf,
            // "pdf-content": PdfContent,
        },
        methods: {
            makePDF() {
                window.html2canvas = html2canvas;
                var doc = new jsPDF("l", "pt", "a4");
                doc.html(document.querySelector("#app"), {
                    callback: function (pdf) {
                        pdf.save("mypdf.pdf");
                    },
                });
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            close() {
                this.$router.push({ name: "certificate-bonafied", target: "blank" });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onload() {
                this.cert_data = this.$route.params.cert_data;
                this.org_basic_data = this.$route.params.org_basic_data;
            },
            async exportToPDF() {
                console.log("hi");
                await html2pdf(this.$refs.document, {
                    enableLinks: false,
                    margin: 0,
                    filename: "document.pdf",
                    image: { type: "jpeg", quality: 0.98 },
                    html2canvas: { scale: 1, useCORS: true },
                    jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
                });
                console.log("hi1");
            },
            generateReport() {
                this.beforeDownload();
                this.$refs.html2Pdf.generatePdf();
            },
            async beforeDownload({ html2pdf, options, pdfContent }) {
                await html2pdf()
                    .set(options)
                    .from(pdfContent)
                    .toPdf()
                    .get("pdf")
                    .then((pdf) => {
                        const totalPages = pdf.internal.getNumberOfPages();
                        for (let i = 1; i <= totalPages; i++) {
                            pdf.setPage(i);
                            pdf.setFontSize(10);
                            pdf.setTextColor(150);
                            pdf.text("Page " + i + " of " + totalPages, pdf.internal.pageSize.getWidth() * 0.88, pdf.internal.pageSize.getHeight() - 0.3);
                        }
                    })
                    .save();
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.onload();
        },
    };
</script>
<style scoped>
  @font-face {
  font-family: 'gregorianFLF';
  src: url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.eot");
}
.header-style{
  font-family:  serif  ;
  font-size: 2em;
}
.header-style::first-letter{
  font-family: 'GregorianFLF', serif ;
}
.header-style .span-first-letter{
  font-family: 'GregorianFLF', serif ;
}
.certificate-text {
    padding: 5px 50px;
    background-color: black; 
    border-radius: 20px;
    color: #ffffff;
    font-weight: bold;
    font-size: 1.2em;
    text-transform: uppercase;
}
.text-css {
  float: left;
  font-weight: bolder;
}

.main-row{
    margin-left: 2px;
    margin-right: 2px;
}
.printdiv{
    padding: 10px;
    margin-left: 6%;
    margin-right: 6%;
    /* background-color: white; */
    position: absolute;
}
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    .cert-box {
        border: 2px solid #0f2027 !important;
        /*margin-top: 2%;
        margin-right: 12%;
        margin-left: 12%;
        padding: 10px; */
        /* margin: 15px !important;
        padding: 8px; */
        margin-top: 5%;
        margin-right: 10%;
        margin-left: 10%;
        padding: 10px;
    }
    .bottomright {
        position: absolute;
        bottom: 8px;
        right: 16px;
        font-size: 18px;
    }
    @media print {
        /* .printdiv{
            height: 1500px;
            width: 2000px;
        } */
        
        
        
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        /* img {
            width: 100% !important;
        } */
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        .v-card {
            font-size: 2em !important;
        }
        @page {
            margin-top: -4px;
            size: A4 landscape;
            /* size: 25.5in 20.5in; */
            size: 25.5in 18.5in;
        }
        * {
            overflow: hidden !important;
        }
    }
</style>
